import { Item } from './item';
import { HostHistoricalApi } from '../../api/models/historical';

export class HostHistorical
{
    hostId: string;
    items: Item[];

    public static mapperFromApi (source: HostHistoricalApi): Item[]
    {
        return source.items.map(Item.mapperFromApi);
    }
}
